<!-- Sales Service -->
<ac-container auto-layout="vertical" width="fill" height="fill" gap-vertical="8">
	<!-- Main Container -->
	<ac-stroke-container auto-layout="vertical" width="fill" height="fill" padding-vertical="16" padding-horizontal="16" corner-radius="16" gap-vertical="12">
		<!-- Topbar -->
		<ac-container width="fill" height="32" alignment="center" gap-horizontal="auto">
			<!-- Icon Title -->
			<ac-container gap-horizontal="8" alignment="left">
				<ac-label [text]="'sales.service.header.orders' | translate" variant="dark" size="large"></ac-label>
			</ac-container>
			<ac-input-field icon="search-sm" width="320" [placeholder]="'sales.service.header.search' | translate"></ac-input-field>
			<ac-button (ButtonEvent.clicked)="showDialog()" icon="plus" [text]="'sales.service.header.new_order' | translate"></ac-button>
		</ac-container>
		<ac-container width="fill" height="fill" auto-layout="vertical" gap-vertical="16">
			<!-- List Header -->
			<ac-container height="32" width="fill" fill="#F5F7FA" corner-radius="8" gap-horizontal="16" alignment="left" padding-horizontal="16">
				<ac-label [text]="'sales.service.table.order_nr' | translate" variant="light" width="168"></ac-label>
				<ac-label [text]="'sales.service.table.customer' | translate" variant="light" width="168"></ac-label>
				<ac-label [text]="'sales.service.table.customer_nr' | translate" variant="light" width="168"></ac-label>
				<ac-label [text]="'sales.service.table.type' | translate" variant="light" width="168"></ac-label>
				<ac-label [text]="'sales.service.table.tags' | translate" variant="light" width="fill"></ac-label>
				<ac-label [text]="'sales.service.table.status' | translate" variant="light" width="112"></ac-label>
				<ac-label [text]="'sales.service.table.price' | translate" variant="light" width="96" text-align-horizontal="right"></ac-label>
				<ac-label [text]="'sales.service.table.date' | translate" variant="light" width="144" text-align-horizontal="right"></ac-label>
			</ac-container>
			<!-- Orders List -->
			<ac-container width="fill" height="fill" auto-layout="vertical" gap-vertical="8" clip-content="true" hide-scrollbars="true">
				@for (order of orders; track order.orderNumber) {
					<!-- Order Row Renderer -->
					<ac-container (dblclick)="orderDoubleClicked(order)" cursor="pointer" alignment="top_left" width="fill" height="hug" min-height="32" gap-horizontal="16" padding-horizontal="16">
						<ac-label [text]="order.orderNumber.value" width="168" variant="dark"></ac-label>
						<ac-label [text]="order.customer.name.value" width="168"></ac-label>
						<ac-label [text]="order.customer.key.value" width="168"></ac-label>
						<ac-label [text]="order.orderType.name.value" width="168"></ac-label>
						<!-- Tags -->
						<ac-container width="fill" gap-horizontal="8" gap-vertical="8" auto-layout="wrap">
							@for (tag of order.tags; track tag) {
								<ac-tag-renderer [data]="tag"></ac-tag-renderer>
							}
						</ac-container>
						<!-- Status -->
						<ac-container width="112">
							<ac-badge [text]="order.status.state.key.value"></ac-badge>
						</ac-container>
						<ac-label [text]="order.totals.subTotalAsCurrency" width="96" text-align-horizontal="right"></ac-label>
						<ac-label [text]="order.orderDateAsLocalized" width="144" text-align-horizontal="right"></ac-label>
					</ac-container>
				}
			</ac-container>
		</ac-container>
	</ac-stroke-container>
</ac-container>

<!-- Create new Order Dialog -->
<dialog #dialog (TagRendererEvent.close)="tagClosed($event)">
	<ac-stroke-container width="400" padding-horizontal="0" padding-vertical="0" clip-content="true">
		<!-- Top Bar -->
		<ac-container padding-horizontal="16" padding-vertical="16" gap-horizontal="16" alignment="left">
			<!-- Icon Ring -->
			<ac-stroke-container width="40" height="40" corner-radius="20" alignment="center" padding-horizontal="0" padding-vertical="0">
				<ac-icon name="file-plus-03"></ac-icon>
			</ac-stroke-container>
			<!-- Information Labels -->
			<ac-container width="fill" auto-layout="vertical">
				<ac-label variant="dark" [text]="'sales.service.dialog.create_new_order' | translate"></ac-label>
				<ac-label size="small" [text]="'sales.service.dialog.choose_parameters_to_continue' | translate"></ac-label>
			</ac-container>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Order Type -->
		<ac-container width="fill" auto-layout="vertical" padding-horizontal="16" padding-vertical="8" gap-vertical="4">
			<ac-label [text]="'sales.service.dialog.order_type' | translate" variant="light"></ac-label>
			<ac-auto-complete [data]="orderTypes" (AutoCompleteEvent.selectedItemChanged)="orderTypeChanged($event)" width="fill" icon="type-01" [placeholder]="'sales.service.dialog.choose_order_type' | translate"></ac-auto-complete>
		</ac-container>
		<!-- Debitor -->
		<ac-container width="fill" auto-layout="vertical" padding-horizontal="16" padding-vertical="8" gap-vertical="4">
			<ac-label [text]="'sales.service.dialog.debitor' | translate" variant="light"></ac-label>
			<ac-auto-complete [data]="debitors" (AutoCompleteEvent.selectedItemChanged)="debitorChanged($event)" icon="search-sm" [placeholder]="'sales.service.dialog.choose_order_type' | translate" width="fill"></ac-auto-complete>
		</ac-container>
		<!-- Tags -->
		<ac-container width="fill" auto-layout="vertical" padding-horizontal="16" padding-vertical="8" gap-vertical="4">
			<ac-label [text]="'sales.service.dialog.tags' | translate" variant="light"></ac-label>
			<ac-container auto-layout="vertical" width="fill" gap-vertical="8">
				<ac-container width="fill" gap-horizontal="8">
					<!-- Key -->
					<ac-input-field maximum-characters="20" #keyInputField (InputFieldEvent.changed)="keyInputFieldChanged($event)" icon="key-01" width="fill"></ac-input-field>
					<!-- Value -->
					<ac-input-field maximum-characters="20" #valueInputField (InputFieldEvent.changed)="valueInputFieldChanged($event)" icon="variable" width="fill"></ac-input-field>
					<!-- Create Tag Button -->
					<ac-button [enabled]="isCreateTagButtonEnabled" (ButtonEvent.clicked)="createTagButtonClicked($event)" icon="arrow-right" text="Tilføj Tag" width="fill"></ac-button>
				</ac-container>
				<!-- Tags Container -->
				<ac-container width="fill" gap-horizontal="8" gap-vertical="8" alignment="right" auto-layout="wrap">
					@for (tag of tags; track tag) {
						<ac-tag-renderer [data]="tag" closeable="true"></ac-tag-renderer>
					}
				</ac-container>
			</ac-container>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Bottom Bar -->
		<ac-container alignment="right" width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="10">
			<ac-button (ButtonEvent.clicked)="closeDialog()" icon="x-close" [text]="'sales.service.dialog.cancel' | translate"></ac-button>
			<ac-button (ButtonEvent.clicked)="continueButtonClicked()" icon="arrow-right" [text]="'sales.service.dialog.continue' | translate" [enabled]="isContinueButtonEnabled"></ac-button>
		</ac-container>
	</ac-stroke-container>
</dialog>
